import { BusinessPartnerPicker } from '@work4all/components/lib/components/entity-picker/business-partner-picker/BusinessPartnerPicker';
import { ContactPicker } from '@work4all/components/lib/components/entity-picker/contact-picker/ContactPicker';
import { CostCenterPicker } from '@work4all/components/lib/components/entity-picker/costCenter-Picker/CostCenterPicker';
import { CustomFieldComboPicker } from '@work4all/components/lib/components/entity-picker/custom-field-combo-picker/CustomFieldComboPicker';
import { CustomerCategoryPicker } from '@work4all/components/lib/components/entity-picker/customer-category-picker/CustomerCategoryPicker';
import { CustomerPicker } from '@work4all/components/lib/components/entity-picker/customer-picker/CustomerPicker';
import {
  ArticleGroupPicker,
  ProjectGroupPicker,
  SupplierGroupPicker,
  TextBuildingBlockGroupPicker,
  UserGroupPicker,
} from '@work4all/components/lib/components/entity-picker/entity-group-picker/EntityGroupPicker';
import { LookUpPicker } from '@work4all/components/lib/components/entity-picker/look-up-picker/LookUpPicker';
import { MailAssignStatusPicker } from '@work4all/components/lib/components/entity-picker/MailAssignStatusPicker/MailAssignStatusPicker';
import { PaymentKindPicker } from '@work4all/components/lib/components/entity-picker/PaymentKindPicker';
import { ProjectCategoryPicker } from '@work4all/components/lib/components/entity-picker/project-category-picker/ProjectCategoryPicker';
import { ProjectPicker } from '@work4all/components/lib/components/entity-picker/project-picker/ProjectPicker';
import { SupplierCategoryPicker } from '@work4all/components/lib/components/entity-picker/supplier-category-picker/SupplierCategoryPicker';
import { SupplierPicker } from '@work4all/components/lib/components/entity-picker/supplier-picker/SupplierPicker';
import { TicketKindPicker } from '@work4all/components/lib/components/entity-picker/TicketKindPicker';
import { UserClassPicker } from '@work4all/components/lib/components/entity-picker/user-class-picker/UserClassPicker';
import { UserPicker } from '@work4all/components/lib/components/entity-picker/user-picker/UserPicker';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';
import { IndividualFieldControlType } from '@work4all/models/lib/Enums/IndividualFieldControlType.enum';

import { CustomerGroupPickerWrapper } from './CustomerGroupPickerWrapper';

export function getConditionalPicker(
  entity: Entities | string,
  type?: IndividualFieldControlType,
  contextEntityType?: Entities
) {
  switch (entity) {
    case Entities.userGroup:
      return UserGroupPicker;
    case Entities.user:
      return UserPicker;
    case Entities.project:
      return ProjectPicker;
    case Entities.customer:
      return CustomerPicker;
    case Entities.supplier:
      return SupplierPicker;
    case Entities.businessPartner:
      return BusinessPartnerPicker;
    case Entities.contact:
      return ContactPicker;
    case Entities.ticketKind:
      return TicketKindPicker;
    case Entities.customerGroup:
      return CustomerGroupPickerWrapper;
    case Entities.supplierGroup:
      return SupplierGroupPicker;
    case Entities.articleGroup:
      return ArticleGroupPicker;
    case Entities.projectGroup:
      return ProjectGroupPicker;
    case Entities.textBuildingBlockGroup:
      return TextBuildingBlockGroupPicker;
    case Entities.lookUp:
      return LookUpPicker;
    case 'userKind':
      return UserClassPicker;
    case Entities.costCenter:
      return CostCenterPicker;
    case 'mailAssignStatus':
      return MailAssignStatusPicker;
    case Entities.customField:
    case Entities.paymentKind:
      return PaymentKindPicker;
      return getConditionalCustomFieldPicker(type);
    case Entities.categoryAssignment:
      return getContextualCategoryPicker(contextEntityType);
    default:
      return null;
  }
}

const getConditionalCustomFieldPicker = (type: IndividualFieldControlType) => {
  switch (type) {
    case IndividualFieldControlType.COMBO:
      return CustomFieldComboPicker;
    default:
      return null;
  }
};

const getContextualCategoryPicker = (contextEntityType?: Entities) => {
  switch (contextEntityType) {
    case Entities.supplier:
      return SupplierCategoryPicker;
    case Entities.project:
      return ProjectCategoryPicker;
    case Entities.customer:
      return CustomerCategoryPicker;
    default:
      return null;
  }
};
